/**
 * Sprint 12+M5.17-t (22.07.2026) — Vimeo Indoctrination-Sequence Config.
 *
 * Sprint M5.37 (29.07.2026) — Block D: Alle Videos statisch verfügbar
 * (unlockOffsetDays=0). Kein Implizit-Versprechen mehr über zeitversetzte
 * Freischaltung. Reihenfolge im Grid nach 4er-Matrix Katze/Eule/Biene/Hund.
 *
 * Sprint M5.48 Hotfix (02.08.2026) — Prelaunch-Pionier bekommt eine
 * gestaffelte Freischaltung wieder aktiviert:
 *   - Intro-Video: Tag 0 (sofort)
 *   - Video des ermittelten Primär-Fokustyps: Tag 0 (dynamisch in
 *     `computeUnlockedCount` auf 0 gemapt)
 *   - Die 3 verbleibenden Fokustyp-Videos: Tag 1, 2, 3
 * Die Anzeige „X von 5 freigeschaltet · Jetzt ansehen" spiegelt den Status.
 */

const CONFIG = [
  {
    key: "intro",
    title: "Einleitung ins Vier-Fokustypen-Modell",
    id: process.env.REACT_APP_VIMEO_VIDEO_INTRO,
    hash: process.env.REACT_APP_VIMEO_VIDEO_INTRO_HASH,
    duration: "90 Sek",
    unlockOffsetDays: 0,
    description: "Warum dein Verhalten sich wiederholt.",
    poster: "/videos/thumb-intro.jpg",
  },
  {
    key: "katze",
    title: "Die Katze",
    id: process.env.REACT_APP_VIMEO_VIDEO_KATZE,
    hash: process.env.REACT_APP_VIMEO_VIDEO_KATZE_HASH,
    duration: "75 Sek",
    unlockOffsetDays: 1,
    description: "Wenn du impulsiv reagierst, bevor du nachdenkst.",
    poster: "/videos/thumb-katze.jpg",
  },
  {
    key: "eule",
    title: "Die Eule",
    id: process.env.REACT_APP_VIMEO_VIDEO_EULE,
    hash: process.env.REACT_APP_VIMEO_VIDEO_EULE_HASH,
    duration: "80 Sek",
    unlockOffsetDays: 2,
    description: "Wenn du dich zu sehr auf die Sache fokussierst und den Menschen übersiehst.",
    poster: "/videos/thumb-eule.jpg",
  },
  {
    key: "biene",
    title: "Die Biene",
    id: process.env.REACT_APP_VIMEO_VIDEO_BIENE,
    hash: process.env.REACT_APP_VIMEO_VIDEO_BIENE_HASH,
    duration: "70 Sek",
    unlockOffsetDays: 3,
    description: "Wenn du absolute Klarheit brauchst, bevor du loslegst.",
    poster: "/videos/thumb-biene.jpg",
  },
  {
    key: "hund",
    title: "Der Hund",
    id: process.env.REACT_APP_VIMEO_VIDEO_HUND,
    hash: process.env.REACT_APP_VIMEO_VIDEO_HUND_HASH,
    duration: "75 Sek",
    unlockOffsetDays: 3,
    description: "Wenn du für alle anderen da bist und dabei manchmal vergisst, Nein zu sagen.",
    poster: "/videos/thumb-hund.jpg",
  },
];

export const VIMEO_VIDEOS = CONFIG.reduce((acc, v) => {
  acc[v.key] = v;
  return acc;
}, {});

export const VIMEO_VIDEO_ORDER = CONFIG;

/**
 * Sprint M5.24.4 (24.07.2026) — Poster-Bild-Hierarchie:
 *   1. Custom Canva-Thumbnail aus `video.poster`
 *   2. Fallback: Vimeo-natives Thumbnail via vumbnail.com
 */
export function vimeoThumbnailUrl(video) {
  if (!video) return null;
  if (video.poster) return video.poster;
  if (!video.id) return null;
  return `https://vumbnail.com/${video.id}.jpg`;
}
